import React from "react";
import { CheckIcon, SparklesIcon } from "lucide-react";
import { offer } from "../data/content";
import { surface } from "../data/theme";
import { BuyButton } from "./BuyButton";
import { Pill } from "./Pill";
import { PriceTag } from "./PriceTag";
import { ProductMockup } from "./ProductMockup";
import { Reveal } from "./Reveal";
import { Section } from "./Section";
export function Offer() {
  return <Section id="oferta" labelledBy="offer-title" className="bg-navy-dots scroll-mt-2" waveTo={surface.white} data-id="element-144" data-mp="ty1v60cyx6au">
      <ProductMockup size="md" data-id="element-145" data-mp="p0tlko5vyal7" />

      <Reveal className="bg-gold-gradient relative mt-8 rounded-[28px] p-[2px] shadow-[0_0_60px_-12px_rgba(242,196,107,0.6)]" data-id="element-146" data-mp="p1uyky6gp75k">
        <div className="overflow-hidden rounded-[26px] bg-white text-center" data-id="element-147" data-mp="yxy2o9kvjfv5">
          <p className="bg-gold-gradient flex items-center justify-center gap-2 px-4 py-3 text-xs font-extrabold uppercase tracking-[0.14em] text-navy" data-id="element-148" data-mp="z00wl4p5dt55">
            <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-149" data-mp="2ac1t55s96lvg" />
            {offer.eyebrow}
          </p>
          <div className="px-5 pb-8 pt-7 sm:px-10" data-id="element-150" data-mp="pjfi048iobg0">
            <h2 id="offer-title" className="font-display text-[1.6rem] font-extrabold leading-tight text-navy sm:text-3xl" data-id="element-151" data-mp="ujbms5p1g6wm">
              {offer.name}
            </h2>
            <p className="mt-2 leading-relaxed text-navy/70" data-id="element-152" data-mp="zj6ci5x2uqg3">{offer.tagline}</p>
            <p className="mt-4 inline-flex rounded-full bg-navy px-3.5 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-gold" data-id="element-153" data-mp="13ip23ezufpp9">
              {offer.badge}
            </p>

            <ul className="mx-auto mt-7 max-w-sm space-y-3 text-left" data-id="element-154" data-mp="btvl3f1ma8em">
              {offer.items.map(item => <li key={item} className="flex items-center gap-3 font-medium text-navy" data-id="element-155" data-mp="ftcrqbss5bld">
                  <span className="bg-gold-gradient flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-navy" data-id="element-156" data-mp="kldyxjb3cc4j">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3.5} aria-hidden="true" data-id="element-157" data-mp="3k845w0xwduw8" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div id="oferta-precio" className="mt-8 scroll-mt-[26vh] rounded-2xl bg-mist px-4 py-6 sm:scroll-mt-[18vh]" data-id="element-158" data-mp="vepap1gjv3v6">
              <p className="font-bold leading-snug text-navy" data-id="element-159" data-mp="155ah3b2gtcon">{offer.priceLead}</p>
              <div className="mt-4" data-id="element-160" data-mp="157d37k0hylo3">
                <PriceTag data-id="element-161" data-mp="1067bnpikp4g5" />
              </div>
            </div>

            <BuyButton label={offer.cta} className="mt-6" data-id="element-162" data-mp="cgv3msyzf2ff" />
            <p className="mt-3 text-sm text-muted" data-id="element-163" data-mp="chemcbwghuui">{offer.ctaNote}</p>

            <div className="mt-6 flex flex-wrap justify-center gap-2 border-t border-line pt-6" data-id="element-164" data-mp="7il82h9chzta">
              {offer.trust.map(seal => <Pill key={seal.label} icon={seal.icon} label={seal.label} tone="light" data-id="element-165" data-mp="licg81d6klzd" />)}
            </div>
          </div>
        </div>
      </Reveal>
    </Section>;
}